module.exports = __webpack_public_path__ + "img/symbol_6.a88061a3.png";